import { memo } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MfaShieldHero from 'modules/authentication/components/MfaShieldHero/MfaShieldHero';

type MfaEnrollmentSuccessProps = {
  onDone: () => void;
};

const MfaEnrollmentSuccess = ({ onDone }: MfaEnrollmentSuccessProps) => {
  const { t } = useTranslation('authentication');

  return (
    <>
      <MfaShieldHero variant='inline' tone='success' size={88} />

      <Typography variant='h1' fontWeight={400} textAlign='center' mt={2}>
        {t('mfa.enrollment.successTitle')}
      </Typography>
      <Typography color='text.secondary' textAlign='center' mt={1} mb={4}>
        {t('mfa.enrollment.successSubtitle')}
      </Typography>

      <Stack alignItems='center'>
        <Button fullWidth variant='contained' size='large' onClick={onDone}>
          {t('mfa.enrollment.done')}
        </Button>
      </Stack>
    </>
  );
};

export default memo(MfaEnrollmentSuccess);
